<template>
  <div>
    <el-button type="text" @click="fetchtext();textdialog=true">
      <i class="el-icon-tickets"></i>
    </el-button>

    <el-dialog v-if="textdialog" :visible.sync="textdialog" fullscreen>
      <div v-if="$store.state.roles.includes('dbadmin') || $store.state.user===rowdata.name">
        <el-button @click="uploadtextfile">提交更改</el-button>
        <el-input type="textarea" autosize :placeholder="defaulttext" v-model="text"></el-input>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { renewitems, itemscollection } from "@/components/utility/indexdb";
export default {
  props: ["rowdata"],
  data() {
    return {
      textdialog: false,
      defaulttext: "无内容",
      text: "",
    };
  },
  mounted() {},
  methods: {
    fetchtext() {
      let self = this;
      this.$axios
        .get(url + "showtext?id=" + self.rowdata._id)
        .then(function (response) {
          self.text = response.data;
        })
        .catch(function (error) {
          self.$store.commit("setloading", false);
        });
    },
    uploadtextfile() {
      let data = {
        id: this.rowdata._id,
        collection: this.$store.state.clct,
        text: this.text,
      };
      this.$axios.post(url + "uploadtextfile", data).then((res) => {
        if (res.data.doc) {
          itemscollection
            .update({ _id: res.data.doc._id }, res.data.doc)
            .then(renewitems());
        }
        this.textdialog = false;
        this.$message("已提交成功");
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/utility/commonfields/textfile.vue